import { isProductionHostname } from '@storebrand-digital/insurance-common';

function getDefaultDisplayFormErrorDebuggerValue(): boolean {
  if (isProductionHostname()) {
    return false;
  }
  return true;
}

export const displayFormErrorDebugger = () => {
  return {
    displayDebugger: getDefaultDisplayFormErrorDebuggerValue,
  };
};
